import React, { useState } from "react";
import "./styles/adminlogin.css";

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await fetch("https://hcfullstack.onrender.com/admin/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, phone, password }),
      });

      const data = await res.json();

      if (!data.success) {
        setError(data.message || "Login failed");
        return;
      }

      // حفظ حالة الدخول
      localStorage.setItem("adminAuth", "true");
      window.location.href = "/AdminPage";
    } catch (err) {
      setError("Server error ❌");
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-card">
        <h2>
          <i className="fa-solid fa-user-shield"></i>
          Admin Login
        </h2>

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <i className="fa-solid fa-user"></i>
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <i className="fa-solid fa-phone"></i>
            <input
              type="text"
              placeholder="Phone number"
              value={phone}
              onChange={(e) =>
                setPhone(e.target.value.replace(/\D/g, ""))
              }
              required
            />
          </div>

          <div className="input-group">
            <i className="fa-solid fa-lock"></i>
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {error && <div className="error-box">{error}</div>}

          <button type="submit" className="login-btn">
            <i className="fa-solid fa-right-to-bracket"></i>
            Login
          </button>
        </form>
      </div>
    </div>
  );
}
